module.exports = __webpack_public_path__ + "static/media/visa.910e2232.png";